import { FC, useState } from "react";
import styles from "./catalogues.module.scss";
import { Search } from "../../ui/search/search";
import { list } from "./list";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";

export const Catalogues: FC = () => {
  const location = useLocation();
  const [searchArg, setSearcArg] = useState("");
  const searchHandler = (arg: string) => {
    setSearcArg(arg);
  };

  const filteredList = list.filter((el) =>
    el.title.toUpperCase().includes(searchArg.toUpperCase())
  );

  return (
    <div className={styles.main}>
      <Search handler={searchHandler} value={searchArg} />
      <ul className={styles.ul}>
        {filteredList.map((item) => {
          return (
            <Link
              to={item.path}
              key={item.path}
              className={classNames(styles.li, {
                [styles.active]: item.path === location.pathname,
              })}
            >
              {item.title}
            </Link>
          );
        })}
      </ul>
    </div>
  );
};
